import script from "./RecipeList.vue?vue&type=script&lang=ts&setup=true"
export * from "./RecipeList.vue?vue&type=script&lang=ts&setup=true"

import "./RecipeList.vue?vue&type=style&index=0&id=24701dbc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24701dbc"]])

export default __exports__